/** Current CrewPilot home. Top-level hub Back lands here. */
export const CURRENT_DASHBOARD_SCREEN = "kpi_dashboard";

/** Retired Cockpit screen. Its visible title is Time & Session. */
export const LEGACY_COMMAND_CENTER_SCREEN = "crewpilot";

/**
 * Top-level hub Back must not open the retired Command Center.
 * A real parent screen (Quick Create, Estimate Hub, Clients, Dashboard)
 * is preserved. Missing values and the Command Center id become the
 * current Dashboard.
 */
export function resolveTopLevelHubReturn(
  returnScreen,
  {
    dashboard = CURRENT_DASHBOARD_SCREEN,
    legacyCommandCenter = LEGACY_COMMAND_CENTER_SCREEN,
  } = {},
) {
  if (typeof returnScreen !== "string" || returnScreen.length === 0) {
    return dashboard;
  }
  if (returnScreen === legacyCommandCenter) {
    return dashboard;
  }
  return returnScreen;
}

/** Project Hub Back. An in-progress estimate conversion returns to that estimate. */
export function projectHubBackTarget({
  fromEstimate = false,
  returnScreen,
  estimateHub = "estimate_hub",
  dashboard = CURRENT_DASHBOARD_SCREEN,
  legacyCommandCenter = LEGACY_COMMAND_CENTER_SCREEN,
} = {}) {
  if (fromEstimate) return estimateHub;
  return resolveTopLevelHubReturn(returnScreen, { dashboard, legacyCommandCenter });
}
